import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseService } from 'src/app/core/base/base.service';

@Injectable({
  providedIn: 'root',
})
export class NotFoundService extends BaseService {
  constructor(protected store: Store<any>) {
    super();
  }
}
